import log from 'loglevel'

export default class Raw {
    static async fetchJson(method, resource, { jwt = undefined, body = undefined, returnOnError = false, acceptLanguage = 'en' }) {
        const options = {
            method,
            mode: 'cors',
            headers: {
                'Content-Type': 'application/ld+json',
                'Accept-Language': acceptLanguage
            }
        }
        if (jwt) {
            options.headers.Authorization = `Bearer ${jwt}`
        }
        if (body) {
            try {
                options.body = JSON.stringify(body)
            } catch {
                throw new Error('Could not parse body to JSON, are you sure you passed an object?')
            }
        }

        log.debug(`🔼 ${method} ${resource} ${jwt ? '(with jwt)' : ''}`)
        const response = await fetch(`${process.env.API_URL}${resource}`, options)

        /* const raw = await response.clone().text(); // don’t consume the original yet
        const trimmed = raw.trim();

        try {
            JSON.parse(trimmed);
        } catch (err) {
            console.error('Parse failed:', err.message);
            // Look at the tail — it usually reveals the culprit (HTML, “OK”, logs, etc.)
            console.log('=== tail ===\n' + trimmed.slice(-800));
        } */

        let json
        try {
            if (method !== 'DELETE') {
                json = await response.json()
            }
        } catch (e) {
            log.debug('Failed to parse JSON:', e);
            const error = new Error('Tried fetching JSON, but response was not OK.')
            error.status = response.status
            error.json = json
            throw error
        }
        log.debug(
            `🔽 ${method} ${resource} ${jwt ? '(with jwt)' : ''}`, '\n',
            json, '\n'
        )
        if (!returnOnError && !response?.ok) {
            const error = new Error('Tried fetching JSON, but response was not OK.')
            error.status = response.status
            error.json = json
            throw error
        }
        return json
    }

    static async getJwt(email, password) {
        const json = await Raw.fetchJson('POST', '/api/authenticate', {
            body: {
                email,
                password,
            },
        })
        return json.token
    }

    static async getJwtViaSso(code) {
        const json = await Raw.fetchJson('POST', '/api/saml/auth', {
            body: {
                code,
            },
        })
        return json.token
    }

    static async getRefreshedJwt(jwt) {
        const json = await Raw.fetchJson('GET', '/api/current/refresh-token', { jwt })
        return json.token
    }

}
